
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16.001","viewBox":"0 0 16 16.001"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M10.586 7.179a1.765 1.765 0 00-1.765-1.766H1.764A1.764 1.764 0 00-.002 7.179v7.058a1.764 1.764 0 001.764 1.764H8.82a1.765 1.765 0 001.765-1.764zm-1.176 0v7.058a.589.589 0 01-.589.588H1.764a.588.588 0 01-.588-.588V7.179a.588.588 0 01.588-.588h7.058a.589.589 0 01.589.588z"}}),_c('path',{staticClass:"a",attrs:{"d":"M6.001 3.529a.588.588 0 01-.588-.588V1.764A1.764 1.764 0 017.177 0h7.058a1.764 1.764 0 011.764 1.764v7.058a1.764 1.764 0 01-1.764 1.764h-1.176a.588.588 0 010-1.176h1.176a.588.588 0 00.588-.588V1.764a.588.588 0 00-.588-.588H7.177a.588.588 0 00-.588.588v1.177a.588.588 0 01-.588.588z"}})])
          )
        }
      }
    